var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 439,
    viewBox: "0 0 539 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.375 111.583L200.918 128.567L131.402 88.2322L161.917 71.2529L230.375 111.583Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.375 201.271L200.918 218.251L131.402 177.921L161.917 160.937L230.375 201.271Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.207 201.271L200.75 218.251L131.234 177.921L161.749 160.937L230.207 201.271Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.918 128.567V218.251",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.184 71.2529V160.936L131.434 177.891V88.2027",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.375 111.288V200.976",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.517 161.999L109.06 178.983L39.5391 138.648L70.0535 121.669L138.517 161.999Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.517 251.683L109.06 268.667L39.5391 228.337L70.0535 211.353L138.517 251.683Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.344 251.683L108.892 268.667L39.3711 228.337L69.8855 211.353L138.344 251.683Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.059 178.983V268.667",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3209 121.669V211.352L39.5703 228.307V138.619",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.52 161.704V251.392",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.164 156.424L388.712 173.408L319.191 133.078L349.706 116.094L418.164 156.424Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.164 246.112L388.712 263.096L319.191 222.761L349.706 205.782L418.164 246.112Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.996 246.112L388.544 263.096L319.023 222.761L349.538 205.782L417.996 246.112Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.711 173.408V263.097",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.973 116.094V205.782L319.223 222.732V133.048",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.164 156.134V245.817",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.426 207.026L479.969 224.01L410.453 183.676L440.968 166.696L509.426 207.026Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.426 296.715L479.969 313.694L410.453 273.364L440.968 256.38L509.426 296.715Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.255 296.715L479.798 313.694L410.277 273.364L440.792 256.38L509.255 296.715Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.965 224.011V313.694",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.226 166.696V256.38L410.48 273.334V183.646",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.426 206.731V296.42",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.32 95.7685L283.772 112.753L353.293 72.4177L322.778 55.4385L254.32 95.7685Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.32 185.457L283.772 202.436L353.293 162.106L322.778 145.122L254.32 185.457Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.488 185.457L283.94 202.436L353.461 162.106L322.946 145.122L254.488 185.457Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.773 112.753V202.436",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.516 55.4385V145.122L353.266 162.077V72.3882",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.32 95.4736V185.162",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.5 55.3603L218.952 72.3396L288.473 32.0096L257.958 15.0254L189.5 55.3603Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.5 145.044L218.952 162.028L288.473 121.698L257.958 104.714L189.5 145.044Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.668 145.044L219.12 162.028L288.641 121.698L258.126 104.714L189.668 145.044Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.953 72.3398V162.028",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.695 15.0254V104.714L288.446 121.668V31.98",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.5 55.0654V144.754",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.742 330.836L288.199 347.815L357.72 307.485L327.205 290.506L258.742 330.836Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.742 420.52L288.199 437.505L357.72 397.175L327.205 380.19L258.742 420.52Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.918 420.52L288.37 437.505L357.891 397.175L327.376 380.19L258.918 420.52Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.199 347.815V437.504",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.941 290.506V380.189L357.692 397.144V307.456",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.742 330.541V420.229",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.914 290.614L230.371 307.593L299.892 267.263L269.377 250.279L200.914 290.614Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.914 380.298L230.371 397.282L299.892 356.947L269.377 339.968L200.914 380.298Z",
    stroke: "#231F20",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09 380.298L230.542 397.282L300.062 356.947L269.548 339.968L201.09 380.298Z",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.371 307.594V397.282",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.113 250.279V339.968L299.864 356.917V267.234",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.914 290.319V380.003",
    stroke: "white",
    strokeWidth: 1.31366,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6133 107.739L526.645 360.435",
    stroke: "white",
    strokeWidth: 7.88691,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.392 330.614L375.792 384.582L154.855 256.404L251.831 202.436L469.392 330.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.207 310.915L162.182 256.946",
    stroke: "white",
    strokeWidth: 7.88691,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.734 238.062C223.356 237.673 222.328 237.378 221.197 237.058C223.317 233.599 225.379 230.249 227.519 226.756C226.427 226.48 225.521 226.254 224.463 225.988C226.446 222.298 228.39 218.687 230.417 214.913C229.182 214.731 228.163 214.583 226.781 214.377C231.174 208.172 233.728 201.235 236.375 193.924C239.135 201.151 241.541 208.153 246.063 214.372C244.68 214.569 243.627 214.716 242.368 214.898C244.39 218.642 246.328 222.224 248.351 225.968C247.352 226.219 246.456 226.446 245.266 226.746C247.401 230.214 249.477 233.59 251.613 237.063C250.446 237.388 249.413 237.673 248.065 238.047C250.766 241.9 253.364 245.595 256.208 249.649H239.194V263.031H233.654V249.742H216.527C219.396 245.654 221.994 241.949 224.734 238.047V238.062Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.098 271.824C338.168 271.558 337.469 271.361 336.707 271.145C338.143 268.808 339.531 266.539 340.982 264.183C340.244 263.996 339.629 263.843 338.916 263.666C340.254 261.172 341.568 258.731 342.94 256.178C342.104 256.055 341.415 255.951 340.48 255.819C343.452 251.622 345.174 246.933 346.965 241.993C348.83 246.879 350.458 251.612 353.514 255.819C352.579 255.951 351.865 256.055 351.014 256.173C352.382 258.702 353.691 261.127 355.059 263.656C354.385 263.829 353.779 263.981 352.972 264.183C354.414 266.53 355.821 268.808 357.263 271.159C356.476 271.381 355.777 271.573 354.862 271.824C356.687 274.426 358.444 276.926 360.367 279.666H348.864V288.714H345.12V279.73H333.543C335.481 276.965 337.238 274.461 339.093 271.824H339.098Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.899 337.016C383.969 336.75 383.27 336.554 382.507 336.337C383.944 334 385.332 331.732 386.783 329.375C386.045 329.188 385.43 329.036 384.716 328.859C386.055 326.364 387.368 323.924 388.741 321.37C387.905 321.247 387.216 321.144 386.281 321.011C389.253 316.814 390.975 312.125 392.766 307.186C394.63 312.071 396.259 316.804 399.314 321.011C398.38 321.144 397.666 321.247 396.815 321.365C398.183 323.894 399.492 326.32 400.859 328.849C400.185 329.021 399.58 329.173 398.773 329.375C400.215 331.722 401.622 334 403.064 336.352C402.276 336.573 401.578 336.765 400.663 337.016C402.488 339.619 404.244 342.118 406.168 344.859H394.665V353.907H390.921V344.923H379.344C381.282 342.158 383.039 339.653 384.894 337.016H384.899Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.82 246.304C203.25 245.861 202.079 245.526 200.795 245.162C203.211 241.226 205.553 237.408 207.993 233.433C206.748 233.118 205.72 232.862 204.515 232.557C206.773 228.36 208.982 224.242 211.295 219.947C209.888 219.74 208.726 219.568 207.152 219.337C212.156 212.271 215.059 204.375 218.075 196.05C221.218 204.276 223.954 212.252 229.105 219.332C227.531 219.558 226.33 219.725 224.894 219.932C227.196 224.193 229.406 228.276 231.708 232.537C230.572 232.823 229.548 233.083 228.2 233.423C230.631 237.374 232.997 241.216 235.428 245.172C234.099 245.541 232.923 245.866 231.388 246.294C234.463 250.678 237.42 254.889 240.658 259.504H221.287V274.742H214.98V259.612H195.477C198.744 254.958 201.7 250.742 204.82 246.294V246.304Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.121 251.096C309.551 250.653 308.38 250.318 307.096 249.954C309.512 246.018 311.854 242.2 314.294 238.225C313.049 237.91 312.021 237.654 310.816 237.349C313.074 233.152 315.283 229.034 317.595 224.739C316.188 224.532 315.027 224.36 313.453 224.129C318.456 217.063 321.359 209.167 324.375 200.842C327.519 209.068 330.255 217.044 335.406 224.124C333.832 224.35 332.631 224.517 331.195 224.724C333.497 228.985 335.706 233.068 338.009 237.329C336.872 237.615 335.849 237.875 334.501 238.215C336.931 242.166 339.298 246.008 341.729 249.964C340.4 250.333 339.224 250.658 337.689 251.086C340.764 255.47 343.721 259.681 346.959 264.296H327.588V279.534H321.281V264.404H301.777C305.044 259.75 308.001 255.534 311.121 251.086V251.096Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.355 350.866C358.785 350.423 357.614 350.089 356.33 349.725C358.746 345.789 361.088 341.971 363.528 337.995C362.284 337.68 361.255 337.424 360.05 337.119C362.308 332.923 364.517 328.804 366.83 324.509C365.423 324.303 364.262 324.13 362.687 323.899C367.691 316.834 370.594 308.937 373.61 300.612C376.754 308.839 379.489 316.814 384.641 323.894C383.066 324.12 381.866 324.288 380.429 324.494C382.732 328.755 384.941 332.839 387.243 337.1C386.107 337.385 385.083 337.646 383.735 337.985C386.166 341.936 388.532 345.779 390.963 349.734C389.634 350.104 388.459 350.428 386.924 350.856C389.999 355.24 392.956 359.452 396.193 364.067H376.823V379.304H370.515V364.175H351.012C354.279 359.521 357.236 355.304 360.355 350.856V350.866Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.28662,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.378 75.7005L162.912 4L6 101.388L177.628 201.537",
    stroke: "white",
    strokeWidth: 5.91395,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.846 137.719L532.216 227.515L373.494 306.581L364.864 311.191L277.375 260.141",
    stroke: "white",
    strokeWidth: 5.91395,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.487 117.987L385.399 129.805V154.189L377.487 158.061L348.754 141.471V108.782V101.396L377.487 117.987Z",
    stroke: "white",
    strokeWidth: 5.25958,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.824 98.4297L348.753 108.782",
    stroke: "white",
    strokeWidth: 5.25958,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.824 123.999L348.753 134.351",
    stroke: "white",
    strokeWidth: 5.25958,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.376 228.586C224.292 226.451 216.248 204.866 214.669 201.275C207.716 185.432 191.928 176.605 175.721 172.866C168.247 171.144 160.562 171.297 153.118 173.028C151.667 173.363 139.337 175.961 139.814 178.017C144.715 199.071 153.699 221.669 176.248 229.162C185.66 232.291 196.066 233.25 205.847 231.489C210.019 230.736 216.656 230.599 220.371 228.586H220.376Z",
    stroke: "white",
    strokeWidth: 5.25958,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.640617bf9ebf1146c5b2f5937181b8f5.svg";
export { ForwardRef as ReactComponent };